
export const tools = [
  {
    id: 1,
    number: 600,
    path: "600",
  },
  {
    id: 2,
    number: 1000,
    path: "1000",
  },
  {
    id: 3,
    number: 2000,
    path: "2000",
  },
  {
    id: 4,
    number: 5000,
    path: "5000",
  },
  {
    id: 5,
    number: 10000,
    path: "10000",
  },
  {
    id: 6,
    number: 50000,
    path: "50000",
  }
];

export const currencies = [
  {
    id: 1,
    number: 6000,
    path: "packet-1",
  },
  {
    id: 2,
    number: 10000,
    path: "packet-2",
  },
  {
    id: 3,
    number: 20000,
    path: "packet-3",
  },
  {
    id: 4,
    number: 50000,
    path: "packet-4",
  },
  {
    id: 5,
    number: 100000,
    path: "packet-5",
  },
  {
    id: 6,
    number: 500000,
    path: "packet-6",
  },
];
